import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '@components/common/Card';
import { useDocumentStats } from '@api/hooks/useDocumentStats';
import { LoadingSpinner } from '@components/common/LoadingSpinner';
import { FileText, Receipt, DollarSign, Clock } from 'lucide-react';

export const StatsCards = () => {
  const navigate = useNavigate();
  const { poCount, receiptCount, invoiceCount, pendingReviewCount, isLoading } = useDocumentStats();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[...Array(4)].map((_, i) => (
          <Card key={i}>
            <LoadingSpinner />
          </Card>
        ))}
      </div>
    );
  }

  const stats = [
    {
      title: 'Visible Purchase Orders',
      value: poCount,
      icon: FileText,
      color: 'bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400',
      action: () =>
        navigate('/records?type=documents&document_type=purchase_order'),
    },
    {
      title: 'Visible Receipts',
      value: receiptCount,
      icon: Receipt,
      color: 'bg-secondary-50 dark:bg-secondary-900/20 text-secondary-600 dark:text-secondary-400',
      action: () =>
        navigate('/records?type=documents&document_type=receipt'),
    },
    {
      title: 'Visible Invoices',
      value: invoiceCount,
      icon: DollarSign,
      color: 'bg-accent-50 dark:bg-accent-900/20 text-accent-600 dark:text-accent-400',
      action: () =>
        navigate('/records?type=documents&document_type=invoice'),
    },
    {
      title: 'Needs Review',
      value: pendingReviewCount,
      icon: Clock,
      color: 'bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400',
      action: () => navigate('/approvals'),
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <button
            key={index}
            onClick={stat.action}
            className="text-left"
          >
            <Card className="cursor-pointer hover:shadow-md transition-shadow h-full">
              <CardContent className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-600 dark:text-gray-400 font-medium">{stat.title}</p>
                  <p className="text-3xl font-bold text-gray-900 dark:text-gray-50 mt-2">{stat.value}</p>
                </div>
                <div className={`p-3 rounded-lg ${stat.color}`}>
                <Icon className="h-6 w-6" />
              </div>
            </CardContent>
            </Card>
          </button>
        );
      })}
    </div>
  );
};
